import React from 'react';
import {
  ButtonSize,
  FormTemplate,
  OptionSelectionButton, TextArea,
  TextInput
} from 'ui-builder';
import { CreateMarketRequest, Market, useMarketsAdminService } from 'nekst-api';
import { Separator, TimezoneDropdown, usePopupFormManager } from 'features/nekst-widgets';
import { StateDropdown } from 'features/tasks-forms';
import useSettingsNavigator from '../../settingsNavigator';
import CreateMarketBasedOnTeamDataForm from './CreateMarketBasedOnTeamDataForm';

export function CreateMarketForm(props: { afterSubmitFunc?: () => void }) {
  const marketsService = useMarketsAdminService();

  const settingsNavigator = useSettingsNavigator();

  return (
    <FormTemplate<CreateMarketRequest, Market>
      title="Add New Market"
      submitFormFunc={async (data) => {
        const result = await marketsService.createMarket(data);
        if (props.afterSubmitFunc) {
          props.afterSubmitFunc();
        }
        return result;
      }}
      afterSubmitFunc={async (data) => {
        settingsNavigator.openAdminSetupAreaVersionPage(
          data.state,
          data.setupArea.id,
          data.setupArea.versions[0].version
        );
      }}
      validationSchema={{
        name: {
          type: 'string',
          constraints: {
            required: true
          }
        },
        alias: {
          type: 'string',
          constraints: {
            required: true,
            minLength: 3,
            maxLength: 30,
            regex: {
              value: /^[A-Za-z][a-zA-Z0-9]+$/,
              message: 'Alias must start with a letter and can only contain letters and numbers.'
            }
          }
        },
        state: {
          type: 'string',
          constraints: {
            required: true
          }
        },
        version: {
          type: 'string',
          constraints: {
            required: true,
            minLength: 3,
            maxLength: 12,
            regex: {
              value: /^[a-zA-Z0-9\\-]+$/,
              message: 'Version can only contain letters, numbers, and dashes.'
            }
          }
        }
      }}
    >
      <TextInput source="name" label="Market Name" />
      <TextArea source="description" label="Market Description" />
      <TextInput source="alias" label="Alias" />
      <StateDropdown source="state" label="State" />
      <TimezoneDropdown source="timezone" label="Timezone" placeholder="Select timezone" />
      <Separator />
      <TextInput source="version" label="Version" />
      <TextArea source="versionDescription" label="Version Description" />
    </FormTemplate>
  );
}

export function CreateMarketButton() {
  const popupFormManager = usePopupFormManager();

  return (
    <OptionSelectionButton
      text="Actions"
      options={[
        {
          label: 'Add Market Manually',
          onSelected: () => {
            popupFormManager.openForm(<CreateMarketForm />)
          },
          value: 'add_market_manually',
        },
        {
          label: 'Create Market From Team Data',
          onSelected: () => {
            popupFormManager.openForm(<CreateMarketBasedOnTeamDataForm />)
          },
          value: 'create_market_from_team_data',
        }
      ]}
      size={ButtonSize.MEDIUM}
    />
  );
}
